import React, { useRef, useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import {
  FaExternalLinkAlt,
  FaChevronLeft,
  FaChevronRight,
  FaNewspaper,
  FaAward,
  FaGlobeAmericas,
} from "react-icons/fa";

/* ─── data ─── */

const mediaOutlets = [
  { name: "La Tercera", domain: "latercera.com", color: "#E31E24" },
  { name: "Diario Financiero", domain: "df.cl", color: "#003B71" },
  { name: "BioBioChile", domain: "biobiochile.cl", color: "#1B5E20" },
  { name: "ADN Radio", domain: "adnradio.cl", color: "#FF6F00" },
  { name: "El Mostrador", domain: "elmostrador.cl", color: "#B71C1C" },
  { name: "La Tribuna", domain: "latribuna.cl", color: "#0D47A1" },
  { name: "Diario Estrategia", domain: "diarioestrategia.cl", color: "#1A237E" },
  { name: "UAI", domain: "uai.cl", color: "#263238" },
];

const pressArticles = [
  {
    source: "La Tercera",
    color: "#E31E24",
    domain: "latercera.com",
    featured: true,
    title:
      "Apple otorga por primera vez premio a estudiante chileno: viajó a Cupertino y conoció a Tim Cook",
    description:
      "Martín Seguel, primer chileno en ganar el Apple Swift Student Challenge, viajó a Cupertino donde conoció a Tim Cook y presentó su app de sustentabilidad ambiental.",
    url: "https://www.latercera.com/tendencias/noticia/apple-otorga-por-primera-vez-premio-a-estudiante-chileno-viajo-a-cupertino-y-conocio-a-tim-cook/A53EZFEKFVDKBPN4WIRZ3ZMM4Y/",
    date: "2024",
  },
  {
    source: "Diario Financiero",
    color: "#003B71",
    domain: "df.cl",
    title:
      "Por primera vez un estudiante chileno gana reconocida competencia de Apple",
    description:
      "Martín Seguel creó Habitree, una app que ayuda a los usuarios a desarrollar hábitos ambientales sustentables rastreando su progreso e impacto ecológico.",
    url: "https://www.df.cl/df-mas/coffee-break/por-primera-vez-un-estudiante-chileno-gana-reconocida-competencia-de-apple",
    date: "2024",
  },
  {
    source: "UAI",
    color: "#263238",
    domain: "uai.cl",
    title: "Estudiante de Ingeniería y Ciencias UAI gana desafío de Apple",
    description:
      'Martín Seguel fue seleccionado como "Distinguished Winner" en el Apple Swift Student Challenge por su app HabiTree sobre hábitos ambientales sustentables.',
    url: "https://www.uai.cl/noticias/ingenieria-y-ciencias/estudiante-de-ingenieria-y-ciencias-uai-gana-desafio-de-apple",
    date: "2024",
  },
  {
    source: "La Tercera",
    color: "#E31E24",
    domain: "latercera.com",
    title:
      "Dos emprendedores fitness y un programador premiado por Apple crean revolucionaria app que ya se usa en Chile y Perú",
    description:
      "Martín Seguel junto a Mauricio Noval e Ignacio Hermosilla lanzaron Gymly, una plataforma SaaS que digitaliza la gestión de gimnasios en Latinoamérica.",
    url: "https://www.latercera.com/emprendimiento/noticia/dos-emprendedores-fitness-y-un-programador-premiado-por-apple-crean-revolucionaria-app-que-ya-se-usa-en-chile-y-peru/",
    date: "2025",
  },
  {
    source: "BioBioChile",
    color: "#1B5E20",
    domain: "biobiochile.cl",
    title:
      "Ingeniero chileno de 22 años fue premiado por Apple tras crear app para digitalizar los gimnasios",
    description:
      "Martín Seguel, reconocido como uno de los 50 mejores jóvenes desarrolladores del mundo por Apple, creó Gymly para optimizar la gestión de gimnasios.",
    url: "https://www.biobiochile.cl/noticias/ciencia-y-tecnologia/moviles-y-apps/2025/09/10/ingeniero-chileno-de-22-anos-fue-premiado-por-apple-tras-crear-app-para-digitalizar-los-gimnasios.shtml",
    date: "2025",
  },
  {
    source: "ADN Radio",
    color: "#FF6F00",
    domain: "adnradio.cl",
    title: "¿Por qué un chileno de 22 años fue premiado por Apple?",
    description:
      "Un joven ingeniero chileno fue premiado por Apple tras ganar el Swift Student Challenge y crear soluciones tecnológicas innovadoras.",
    url: "https://www.adnradio.cl/2025/09/10/por-que-un-chileno-de-22-anos-fue-premiado-por-apple/",
    date: "2025",
  },
  {
    source: "La Tribuna",
    color: "#0D47A1",
    domain: "latribuna.cl",
    featured: true,
    title:
      "De Los Ángeles a convertirse en uno de los 50 mejores desarrolladores del mundo: la historia de Martín Seguel",
    description:
      "Pese a recibir oferta de Apple en Silicon Valley, Martín Seguel eligió volver a Chile y fundar Monaco IT Services, creando Gymly para digitalizar gimnasios en toda Latinoamérica.",
    url: "https://www.latribuna.cl/cronica-ciudadana/2025/10/01/de-los-angeles-a-convertirse-en-uno-de-los-50-mejores-desarrolladores-del-mundo-la-historia-de-martin-seguel.html",
    date: "2025",
  },
  {
    source: "El Mostrador",
    color: "#B71C1C",
    domain: "elmostrador.cl",
    title:
      "Fitness digital: joven chileno premiado por Apple crea app para transformar la gestión de gimnasios",
    description:
      "Martín Seguel desarrolló Gymly para modernizar la industria fitness en Chile, donde menos del 30% de los gimnasios usa tecnología integrada.",
    url: "https://www.elmostrador.cl/agenda-pais/agenda-digital/2025/10/07/fitness-digital-joven-chileno-premiado-por-apple-crea-app-para-transformar-la-gestion-de-gimnasios/",
    date: "2025",
  },
  {
    source: "Diario Estrategia",
    color: "#1A237E",
    domain: "diarioestrategia.cl",
    title:
      "De Apple al mercado fitness: chileno premiado lanza plataforma para digitalizar gimnasios de la región",
    description:
      "Martín Seguel lanzó Gymly, una plataforma SaaS que centraliza control de acceso, automatización de pagos y planificación de entrenamientos para gimnasios.",
    url: "https://www.diarioestrategia.cl/texto-diario/mostrar/5422380/apple-mercado-fitness-chileno-premiado-firma-tecnologica-lanza-plataforma-digitalizar-gimnasios-region",
    date: "2025",
  },
  {
    source: "La Tribuna",
    color: "#0D47A1",
    domain: "latribuna.cl",
    title:
      "Dos talentos del Biobío entre los 100 Jóvenes Líderes de 2024",
    description:
      "Martín Seguel fue reconocido como uno de los 100 Jóvenes Líderes de 2024 por su contribución al desarrollo tecnológico desde la región del Biobío.",
    url: "https://www.latribuna.cl/cronica-ciudadana/2024/12/27/dos-talentos-del-biobio-entre-los-100-jovenes-lideres-de-2024-leoncio-cabrera-y-martin-seguel.html",
    date: "2024",
  },
  {
    source: "Instagram",
    color: "#E1306C",
    domain: "instagram.com",
    title: "Monaco IT Services — Destacado",
    description:
      "Publicación destacada de Monaco IT Services en Instagram mostrando los últimos logros y proyectos del equipo.",
    url: "https://www.instagram.com/p/DOb0zwQkxNA/",
    date: "2025",
  },
];

/* ─── animations ─── */

const marqueeScroll = keyframes`
  0%   { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

/* ─── styled components ─── */

const PressSection = styled.section`
  padding: 100px 0 80px;
  background: #0f1123;
  overflow: hidden;

  @media (max-width: 900px) {
    padding: 60px 0 40px;
  }
`;

/* ── header ── */

const Header = styled.div`
  text-align: center;
  margin-bottom: 48px;
  padding: 0 20px;
`;

const PressTag = styled.span`
  display: inline-block;
  background: rgba(0, 200, 255, 0.08);
  border: 1px solid rgba(0, 200, 255, 0.2);
  color: #00c8ff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  padding: 8px 20px;
  border-radius: 50px;
  margin-bottom: 24px;
`;

const PressTitle = styled.h2`
  font-size: 2.8em;
  color: #ffffff;
  font-weight: 800;
  letter-spacing: -0.5px;
  margin-bottom: 16px;

  span {
    background: linear-gradient(135deg, #00c8ff, #005bea);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  @media (max-width: 900px) {
    font-size: 2em;
  }
`;

const PressSubtitle = styled.p`
  color: rgba(255, 255, 255, 0.5);
  font-size: 1.1em;
  max-width: 550px;
  margin: 0 auto;
  line-height: 1.6;

  @media (max-width: 900px) {
    font-size: 1em;
  }
`;

/* ── logo marquee ── */

const MarqueeWrapper = styled.div`
  position: relative;
  margin-bottom: 56px;
  padding: 28px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    width: 120px;
    z-index: 2;
    pointer-events: none;
  }
  &::before {
    left: 0;
    background: linear-gradient(90deg, #0f1123 0%, transparent 100%);
  }
  &::after {
    right: 0;
    background: linear-gradient(270deg, #0f1123 0%, transparent 100%);
  }
`;

const MarqueeTrack = styled.div`
  display: flex;
  width: max-content;
  animation: ${marqueeScroll} 30s linear infinite;

  &:hover {
    animation-play-state: paused;
  }
`;

const MarqueeItem = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 0 40px;
  white-space: nowrap;
  cursor: default;

  @media (max-width: 600px) {
    padding: 0 24px;
  }
`;

const LogoIcon = styled.img`
  width: 28px;
  height: 28px;
  border-radius: 6px;
  object-fit: contain;
  background: #ffffff;
  padding: 3px;
`;

const LogoName = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.45);
  letter-spacing: 0.5px;
  transition: color 0.3s ease;

  ${MarqueeItem}:hover & {
    color: rgba(255, 255, 255, 0.8);
  }
`;

/* ── stats ── */

const StatsRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 48px;
  margin-bottom: 56px;
  padding: 0 20px;

  @media (max-width: 600px) {
    gap: 24px;
    flex-wrap: wrap;
  }
`;

const StatItem = styled.div`
  text-align: center;
`;

const StatIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgba(0, 200, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
  color: #00c8ff;
  font-size: 18px;
`;

const StatNumber = styled.div`
  font-size: 2em;
  font-weight: 800;
  color: #ffffff;
  line-height: 1;
  margin-bottom: 4px;

  @media (max-width: 600px) {
    font-size: 1.6em;
  }
`;

const StatLabel = styled.div`
  font-size: 13px;
  color: rgba(255, 255, 255, 0.4);
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 600;
`;

/* ── carousel ── */

const CarouselWrapper = styled.div`
  position: relative;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 60px;

  @media (max-width: 900px) {
    padding: 0 20px;
  }
`;

const CarouselTrack = styled.div`
  display: flex;
  gap: 20px;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: 8px 4px 24px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const NavButton = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== "direction",
})`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${({ direction }) => (direction === "left" ? "left: 12px;" : "right: 12px;")}
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
  z-index: 3;

  &:hover {
    background: #00c8ff;
    border-color: #00c8ff;
    box-shadow: 0 0 30px rgba(0, 200, 255, 0.3);
  }

  @media (max-width: 900px) {
    display: none;
  }
`;

/* ── article cards ── */

const Card = styled.a.withConfig({
  shouldForwardProp: (prop) => !["accentColor", "isFeatured"].includes(prop),
})`
  min-width: ${({ isFeatured }) => (isFeatured ? "420px" : "340px")};
  max-width: ${({ isFeatured }) => (isFeatured ? "420px" : "340px")};
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  padding: 0;
  text-decoration: none;
  color: inherit;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: ${({ accentColor }) => accentColor || "#00c8ff"};
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  &:hover {
    transform: translateY(-8px);
    background: rgba(255, 255, 255, 0.06);
    border-color: rgba(255, 255, 255, 0.12);
    box-shadow: 0 24px 64px rgba(0, 0, 0, 0.4);

    &::before {
      opacity: 1;
    }
  }

  @media (max-width: 600px) {
    min-width: 300px;
    max-width: 300px;
  }
`;

const CardBody = styled.div`
  padding: 28px 24px;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const CardSourceRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
`;

const SourcePill = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "accentColor",
})`
  display: flex;
  align-items: center;
  gap: 10px;
  background: ${({ accentColor }) =>
    accentColor ? `${accentColor}15` : "rgba(0,200,255,0.08)"};
  padding: 6px 14px 6px 8px;
  border-radius: 50px;
`;

const SourceLogo = styled.img`
  width: 22px;
  height: 22px;
  border-radius: 5px;
  object-fit: contain;
  background: #ffffff;
  padding: 2px;
`;

const SourceName = styled.span.withConfig({
  shouldForwardProp: (prop) => prop !== "accentColor",
})`
  font-size: 12px;
  font-weight: 700;
  color: ${({ accentColor }) => accentColor || "#00c8ff"};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const CardDate = styled.span`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.3);
  font-weight: 500;
`;

const CardTitle = styled.h3.withConfig({
  shouldForwardProp: (prop) => prop !== "isFeatured",
})`
  font-size: ${({ isFeatured }) => (isFeatured ? "18px" : "16px")};
  font-weight: 700;
  color: #ffffff;
  line-height: 1.5;
  margin-bottom: 12px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const CardDescription = styled.p`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.45);
  line-height: 1.65;
  margin-bottom: 24px;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: auto;
`;

const ReadLink = styled.span.withConfig({
  shouldForwardProp: (prop) => prop !== "accentColor",
})`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: ${({ accentColor }) => accentColor || "#00c8ff"};
  transition: gap 0.3s ease;

  svg {
    font-size: 10px;
    transition: transform 0.3s ease;
  }

  ${Card}:hover & {
    gap: 12px;
    svg {
      transform: translateX(2px);
    }
  }
`;

const FeaturedBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(0, 200, 255, 0.1);
  border: 1px solid rgba(0, 200, 255, 0.2);
  color: #00c8ff;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 4px 12px;
  border-radius: 50px;
`;

/* ─── component ─── */

export const Press = () => {
  const trackRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const checkScroll = () => {
    if (trackRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = trackRef.current;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 10);
    }
  };

  useEffect(() => {
    checkScroll();
    const track = trackRef.current;
    if (track) {
      track.addEventListener("scroll", checkScroll);
      return () => track.removeEventListener("scroll", checkScroll);
    }
  }, []);

  const scroll = (dir) => {
    if (trackRef.current) {
      trackRef.current.scrollBy({
        left: dir === "left" ? -380 : 380,
        behavior: "smooth",
      });
    }
  };

  const faviconUrl = (domain) =>
    `https://www.google.com/s2/favicons?domain=${domain}&sz=64`;

  /* duplicate the list for seamless marquee */
  const marqueeItems = [...mediaOutlets, ...mediaOutlets];

  return (
    <PressSection id="press">
      {/* ── header ── */}
      <Header>
        <PressTag>Cobertura de prensa</PressTag>
        <PressTitle>
          En los <span>Medios</span>
        </PressTitle>
        <PressSubtitle>
          Los principales medios de comunicación de Chile y Latinoamérica han
          destacado nuestro trabajo e innovación.
        </PressSubtitle>
      </Header>

      {/* ── marquee ── */}
      <MarqueeWrapper>
        <MarqueeTrack>
          {marqueeItems.map((m, i) => (
            <MarqueeItem key={i}>
              <LogoIcon
                src={faviconUrl(m.domain)}
                alt={m.name}
                loading="lazy"
              />
              <LogoName>{m.name}</LogoName>
            </MarqueeItem>
          ))}
        </MarqueeTrack>
      </MarqueeWrapper>

      {/* ── stats ── */}
      <StatsRow>
        <StatItem>
          <StatIcon>
            <FaNewspaper />
          </StatIcon>
          <StatNumber>12+</StatNumber>
          <StatLabel>Publicaciones</StatLabel>
        </StatItem>
        <StatItem>
          <StatIcon>
            <FaGlobeAmericas />
          </StatIcon>
          <StatNumber>8</StatNumber>
          <StatLabel>Medios</StatLabel>
        </StatItem>
        <StatItem>
          <StatIcon>
            <FaAward />
          </StatIcon>
          <StatNumber>100</StatNumber>
          <StatLabel>Jóvenes Líderes</StatLabel>
        </StatItem>
      </StatsRow>

      {/* ── carousel ── */}
      <CarouselWrapper>
        {canScrollLeft && (
          <NavButton direction="left" onClick={() => scroll("left")}>
            <FaChevronLeft />
          </NavButton>
        )}

        <CarouselTrack ref={trackRef}>
          {pressArticles.map((a, i) => (
            <Card
              key={i}
              href={a.url}
              target="_blank"
              rel="noopener noreferrer"
              accentColor={a.color}
              isFeatured={a.featured}
            >
              <CardBody>
                <CardSourceRow>
                  <SourcePill accentColor={a.color}>
                    <SourceLogo
                      src={faviconUrl(a.domain)}
                      alt={a.source}
                      loading="lazy"
                    />
                    <SourceName accentColor={a.color}>{a.source}</SourceName>
                  </SourcePill>
                  <CardDate>{a.date}</CardDate>
                </CardSourceRow>

                <CardTitle isFeatured={a.featured}>{a.title}</CardTitle>
                <CardDescription>{a.description}</CardDescription>

                <CardFooter>
                  <ReadLink accentColor={a.color}>
                    Leer artículo <FaExternalLinkAlt />
                  </ReadLink>
                  {a.featured && <FeaturedBadge>Destacado</FeaturedBadge>}
                </CardFooter>
              </CardBody>
            </Card>
          ))}
        </CarouselTrack>

        {canScrollRight && (
          <NavButton direction="right" onClick={() => scroll("right")}>
            <FaChevronRight />
          </NavButton>
        )}
      </CarouselWrapper>
    </PressSection>
  );
};
